import { useQuery } from "@tanstack/react-query";
import { ApiGetAIFTokenPrice } from "@/api";
import type { AIFTokenPriceItem } from "@/api/types";

/**
 * 来自后端聚合数据的 AIF/TSK 代币行情。
 *
 * 与默认 `useAifPrice`（基于链上 LP 即时计算单价）相互独立：
 * - 本 hook：拿后端封装好的 `item`（含 24h 涨跌幅、市值、更新时间）。
 * - `useAifPrice`：仅返回链上 LP 即时单价（number）。
 *
 * 命名按用户要求使用 `useAifPriceFromBackend`，因为
 * `useAifPrice` 已被链上版占用。
 *
 * 用法：
 * ```ts
 * const { data: aif } = useAifPriceFromBackend();
 * const priceUsd = Number(aif?.currentPriceUsd ?? 0);
 * ```
 */
export function useAifPriceFromBackend(enabled: boolean = true) {
  return useQuery<AIFTokenPriceItem | undefined>({
    queryKey: ["aifTokenPrice"],
    queryFn: async () => {
      const res = await ApiGetAIFTokenPrice({});
      // console.log("aifPriceFromBackend res", res.data);
      return res.data?.item;
    },
    refetchInterval: 3000,
    enabled,
  });
}

export default useAifPriceFromBackend;
